import React, { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import XingView from '@xingternal/xing-view';
import { TopBar } from '@xingternal/top-bar';
import { useServerData } from '@xingternal/hops';

import { useXingFrame } from '@/hooks/useXingFrame';

import { LoggedInContent } from './LoggedInContent';

type LoggedInPageProps = {
  children?: ReactNode;
};
const LoggedInPage: FC<LoggedInPageProps> = ({ children }) => {
  const { featureSwitches } = useXingFrame();
  const { isWebview } = useServerData();
  const { formatMessage } = useIntl();

  const isArmstrong =
    featureSwitches?.filter((x) => x === 'armstrong_v1').length > 0;

  if (isWebview) {
    return <LoggedInContent>{children}</LoggedInContent>;
  }

  return (
    <XingView withSubNav={isArmstrong}>
      {isArmstrong && (
        <TopBar
          title={formatMessage({ id: 'SE_LABEL_COMPANIES' })}
          type="subheader"
        />
      )}
      <LoggedInContent>{children}</LoggedInContent>
    </XingView>
  );
};

LoggedInPage.propTypes = {
  children: PropTypes.node.isRequired,
} as React.WeakValidationMap<LoggedInPageProps>;

export default LoggedInPage;
